import { render, staticRenderFns } from "./tabs2.vue?vue&type=template&id=475eab72&scoped=true"
import script from "./tabs2.vue?vue&type=script&lang=js"
export * from "./tabs2.vue?vue&type=script&lang=js"
import style0 from "./tabs2.vue?vue&type=style&index=0&id=475eab72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475eab72",
  null
  
)

export default component.exports